/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Audience_Persona3Inputs */

const zh_landing_audience_persona3 = /** @type {(inputs: Landing_Audience_Persona3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`终身学习者`)
};

const en_landing_audience_persona3 = /** @type {(inputs: Landing_Audience_Persona3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lifelong Learners`)
};

const es_landing_audience_persona3 = /** @type {(inputs: Landing_Audience_Persona3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprendices de por vida`)
};

/**
* | output |
* | --- |
* | "Lifelong Learners" |
*
* @param {Landing_Audience_Persona3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_audience_persona3 = /** @type {((inputs?: Landing_Audience_Persona3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Audience_Persona3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_audience_persona3(inputs)
	if (locale === "en") return en_landing_audience_persona3(inputs)
	return es_landing_audience_persona3(inputs)
});